module.exports = __webpack_public_path__ + "img/img_quilt02@3x.b7ab8d78.png";